import {deepCopy, generateRandomPoint} from './functions'
import { useContext } from 'react'
import { stateContext } from './ctx'
import { icons } from './icons'
const Adder = () => {

	const {schema,setSchema} = useContext(stateContext)
    const addPoint = () => {

		const nw = generateRandomPoint();
		const newSchema = deepCopy(schema)
		newSchema.unshift(nw)
		
		setSchema(newSchema)


	}


	return <div className='btn' onClick={addPoint}>
       {icons.add}
	</div>
  
}
export default Adder;